import styles from "../../../styles/components/Modal/Filter/Sidebar.module.css"
import React, { useState, useContext } from 'react'
import { LangContext } from "../../../context/LangContext";

const translations = {
  ru: { general: "Общие" },
  en: { general: "General" },
};

export const Sidebar = () => {
  const { langSelected } = useContext(LangContext);
  const t = translations[langSelected] || translations.ru;
  const [activeTab, setActiveTab] = useState("General")
  return (

<div className={styles.sidebar}>
  <div onClick={() => setActiveTab('General')} className={`${styles.tab} ${activeTab === 'General' ? styles.sidebarItemGeneral : ''}`}>{t.general}</div>
  {/* <div onClick={() => setActiveTab('Finance')} className={`${styles.tab} ${activeTab === 'Finance' ? styles.sidebarItemFinance : ''}`}>Финансы</div> */}


</div>


  )
}
